function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { productActivityListApi, productDeleteApi, putOnShellApi, offShellApi, productHeadersApi } from '@/api/product';
import { merCategoryListApi } from '@/api/merchant';
import { mapGetters } from 'vuex';
import store from '@/store';
export default {
  name: 'GoodList',
  props: {
    handleNum: {
      type: String,
      default: ''
    },
    checked: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxLen: {
      type: Number,
      default: function _default() {
        return 100;
      }
    }
  },
  data: function data() {
    return {
      templateRadio: 0,
      props: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      merProps: {
        value: 'id',
        label: 'name',
        children: 'merchantList',
        expandTrigger: 'hover',
        //checkStrictly: true,
        emitPath: false,
        multiple: true
      },
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 10,
        categoryId: '',
        name: '',
        isShow: '',
        merIds: '',
        merStars: ''
      },
      merIds: [],
      name: '',
      categoryList: [],
      imgList: [],
      multipleSelection: [],
      checkedPage: [],
      isChecked: false,
      isIndex: 0,
      checkBox: [],
      merSelect: [],
      checkedIds: [] // 订单当前页选中的数据
    };
  },
  computed: {
    handleNumFilter: function handleNumFilter() {
      return this.handleNum === 'many' || this.handleNum === 'indexActivity';
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (!store.getters.adminProductClassify.length) store.dispatch('product/getAdminProductClassify');
    this.$nextTick(function () {
      _this.categoryList = store.getters.adminProductClassify;
    });
    this.getMerchantList();
    this.getList();
    if (this.checked.length) {
      var _this$checked = _toArray(this.checked),
        arr2 = _this$checked.slice(0);
      this.checkBox = arr2;
      this.checkedIds = arr2.map(function (item) {
        return item.id;
      });
    }
  },
  methods: {
    close: function close() {
      this.$emit('closeDialog', null);
    },
    onInput: function onInput(e) {
      this.$forceUpdate();
    },
    // 商户列表
    getMerchantList: function getMerchantList() {
      var _this2 = this;
      merCategoryListApi().then(function (res) {
        _this2.merSelect = res;
      });
    },
    changeType: function changeType(v) {
      this.isChecked = v;
      var index = this.checkedPage.indexOf(this.tableFrom.page);
      this.isIndex = index;
      this.checkedPage.push(this.tableFrom.page);
      if (index > -1) {
        this.checkedPage.splice(index, 1);
      }
      this.syncCheckedId(v);
    },
    changeOne: function changeOne(v, order) {
      if (v) {
        var index = this.checkedIds.indexOf(order.id);
        if (index === -1) {
          this.checkedIds.push(order.id);
          this.checkBox.push(order);
        }
      } else {
        var _index = this.checkedIds.indexOf(order.id);
        if (_index > -1) {
          this.checkedIds.splice(_index, 1);
          this.checkBox.splice(_index, 1);
        }
      }
    },
    syncCheckedId: function syncCheckedId(o) {
      var _this3 = this;
      var ids = this.tableData.data.map(function (v) {
        return v.id;
      });
      if (o) {
        this.tableData.data.forEach(function (item) {
          var index = _this3.checkedIds.indexOf(item.id);
          if (index === -1) {
            _this3.checkedIds.push(item.id);
            _this3.checkBox.push(item);
          }
        });
      } else {
        this.tableData.data.forEach(function (item) {
          var index = _this3.checkedIds.indexOf(item.id);
          if (index > -1) {
            _this3.checkedIds.splice(index, 1);
            _this3.checkBox.splice(index, 1);
          }
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var tables = [];
      val.map(function (item) {
        tables.push({
          src: item.image,
          id: item.id
        });
      });
      this.multipleSelection = tables;
    },
    handleSubmit: function handleSubmit() {
      if (this.checkBox.length > this.maxLen) return this.$message.warning("\u6700\u591A\u53EF\u9009\u62E9".concat(this.maxLen, "\u4E2A\u5546\u54C1"));
      this.$emit('getStoreItem', this.checkBox);
    },
    getTemplateRow: function getTemplateRow(row) {
      this.$emit('getStoreItem', row);
    },
    getList: function getList(num) {
      var _this4 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.name = encodeURIComponent(this.name);
      this.tableFrom.merIds = this.merIds.toString();
      var params = _objectSpread(_objectSpread({}, this.tableFrom), {}, {
        productChannelLibraryId: store.state.mobildConfig.pageChannelId
      });
      productActivityListApi(params).then(function (res) {
        _this4.tableData.data = res.list;
        _this4.tableData.total = res.total;
        // res.list.map((item) => {
        //   this.imgList.push(item.image)
        // })
        _this4.tableData.data.forEach(function (item) {
          _this4.checked.forEach(function (element) {
            if (Number(item.id) === Number(element.id)) {
              _this4.$nextTick(function () {
                _this4.$refs.multipleTable.toggleRowSelection(item, true);
              });
            }
          });
        });
        _this4.listLoading = false;
      }).catch(function (res) {
        _this4.listLoading = false;
        _this4.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};